import Vue from "vue";

Vue.filter('lotno', function (lotno) {
  return lotno;
  // return lotno.padStart(7, '0')
})
